// Zorura storefront behaviour.
// Part 1: header search type chooser. Dedupes stale types, PRUNES types that no
//         longer have a live product, and makes the picker actually search.
// Part 2: cart drawer bottom inset, measured, so the draft preview bar cannot
//         cover the Checkout button. Returns 0 on the published store.
// Part 3: green in stock dot on the product page flash line, which is a rich
//         text block with no class of its own and so cannot be targeted in CSS.
// Part 4: centre the collection pagination footer on the WINDOW rather than on
//         its container, which starts after the filter sidebar.

(function () {
  /* ---- Part 1 ---- */

  function dedupeTypeOptions() {
    var selects = document.querySelectorAll('select.quick-search__type-select');
    Array.prototype.forEach.call(selects, function (sel) {
      var seen = {};
      Array.prototype.slice.call(sel.options).forEach(function (opt) {
        var val = (opt.value || '').trim();
        if (val === '') return;
        var key = val.toLowerCase();
        if (seen[key]) {
          if (opt.parentNode) opt.parentNode.removeChild(opt);
        } else {
          seen[key] = true;
        }
      });
    });
  }

  /* Prune dead types.
     The dropdown is built in Liquid from collections.all.all_types, which is a
     cached index and has twice now been wrong: it held a stale lowercase
     "Pendant light" long after no product carried that value, and it keeps a
     type listed when the only product of that type is set to draft. Either way
     the customer picks a category and lands on an empty search.

     /collections/all/products.json only ever returns products that are live on
     the storefront, so it is the authoritative list. Any option not in it gets
     removed. This self-heals in BOTH directions: draft a product and its type
     disappears, publish it again and the type comes back, with no code change.

     Cached for ten minutes so republishing a product shows up quickly without
     refetching on every page view. Any failure leaves the dropdown exactly as
     the theme rendered it. */

  var LIVE_TYPES_KEY = 'zorura:liveProductTypes';
  var LIVE_TYPES_TTL = 10 * 60 * 1000;
  var liveTypes = null;

  function applyLiveTypes() {
    if (!liveTypes) return;
    var selects = document.querySelectorAll('select.quick-search__type-select');
    Array.prototype.forEach.call(selects, function (sel) {
      Array.prototype.slice.call(sel.options).forEach(function (opt) {
        var val = (opt.value || '').trim();
        if (val === '') return; // the label and "All products" both carry no value
        if (liveTypes[val.toLowerCase()]) return;
        var wasSelected = opt.selected;
        if (opt.parentNode) opt.parentNode.removeChild(opt);
        if (wasSelected && sel.options.length) sel.selectedIndex = 0;
      });
    });
  }

  function loadLiveTypes() {
    try {
      var raw = window.sessionStorage.getItem(LIVE_TYPES_KEY);
      if (raw) {
        var cached = JSON.parse(raw);
        if (cached && cached.at && (Date.now() - cached.at) < LIVE_TYPES_TTL && cached.map) {
          liveTypes = cached.map;
          applyLiveTypes();
          return;
        }
      }
    } catch (e) { /* private mode, or bad JSON. Fall through and fetch. */ }

    if (!window.fetch) return;

    window.fetch('/collections/all/products.json?limit=250', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (j) {
        if (!j || !j.products || !j.products.length) return;
        var map = {};
        j.products.forEach(function (p) {
          var t = (p.product_type || '').trim();
          if (t) map[t.toLowerCase()] = true;
        });
        // An empty map would blank the whole dropdown. Never trust that.
        if (!Object.keys(map).length) return;
        liveTypes = map;
        try {
          window.sessionStorage.setItem(LIVE_TYPES_KEY, JSON.stringify({ at: Date.now(), map: map }));
        } catch (e) { /* no-op */ }
        applyLiveTypes();
      })
      .catch(function () { /* leave the dropdown as the theme rendered it */ });
  }

  function onChange(evt) {
    var sel = evt.target;
    if (!sel || sel.tagName !== 'SELECT') return;
    if (!sel.classList || !sel.classList.contains('quick-search__type-select')) return;

    var type = (sel.value || '').trim();
    if (type === '') return;

    var form = sel.form || (sel.closest ? sel.closest('form') : null);
    var input = form ? form.querySelector('[data-quick-search-input]') : null;
    var q = input && input.value ? input.value.trim() : '';

    var params = [];
    if (q === '') {
      params.push('q=' + encodeURIComponent('"' + type + '"'));
      params.push('options%5Bfields%5D=product_type');
    } else {
      params.push('q=' + encodeURIComponent(q));
      params.push('options%5Bprefix%5D=last');
      params.push('filter.p.product_type=' + encodeURIComponent(type));
    }
    params.push('type=product');

    window.location.href = '/search?' + params.join('&');
  }

  function tidyHeading() {
    var heading = document.querySelector('.search-header__text-container-heading');
    if (!heading) return;
    var raw = '';
    try {
      raw = (new URLSearchParams(window.location.search).get('q') || '').trim();
    } catch (e) { return; }
    if (raw.length < 3 || raw.charAt(0) !== '"' || raw.charAt(raw.length - 1) !== '"') return;
    var phrase = raw.slice(1, -1).trim();
    if (phrase === '') return;
    heading.textContent = phrase;
    document.title = phrase + ' – Zorura';
  }

  /* ---- Part 2 ---- */

  var BASE_PAD = 16;
  var MAX_INSET = 240;

  function measureBottomInset() {
    var vh = window.innerHeight;
    if (!vh || !document.body) return 0;
    var inset = 0;
    var nodes = Array.prototype.slice.call(document.body.children);
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      var tag = el.tagName;
      if (tag === 'SCRIPT' || tag === 'STYLE' || tag === 'LINK' || tag === 'NOSCRIPT') continue;
      if (el.classList && (el.classList.contains('shopify-section') || el.id === 'MainContent')) continue;
      if (el.querySelector && el.querySelector('.quick-cart')) continue;
      var cs;
      try { cs = getComputedStyle(el); } catch (e) { continue; }
      if (cs.position !== 'fixed' && cs.position !== 'sticky') continue;
      if (cs.display === 'none' || cs.visibility === 'hidden' || cs.opacity === '0') continue;
      var r = el.getBoundingClientRect();
      if (r.width < 40 || r.height < 8) continue;
      if (r.bottom < vh - 8) continue;
      if (r.top < vh * 0.5) continue;
      inset = Math.max(inset, Math.min(vh - r.top, MAX_INSET));
    }
    return Math.round(inset);
  }

  function applyBottomInset() {
    var footers = document.querySelectorAll('.quick-cart__footer');
    if (!footers.length) return;
    var inset = measureBottomInset();
    for (var i = 0; i < footers.length; i++) {
      if (inset > 0) {
        footers[i].style.setProperty('padding-bottom', (BASE_PAD + inset) + 'px', 'important');
      } else {
        footers[i].style.removeProperty('padding-bottom');
      }
    }
  }

  /* ---- Part 3 ---- */

  function addStockDot() {
    var paras = document.querySelectorAll('.product-blocks .rte p, .product__description p');
    for (var i = 0; i < paras.length; i++) {
      var p = paras[i];
      if (p.querySelector('.zorura-stock-dot')) continue;
      var text = (p.textContent || '').trim();
      if (!/^in stock\b/i.test(text)) continue;
      var dot = document.createElement('span');
      dot.className = 'zorura-stock-dot';
      dot.setAttribute('aria-hidden', 'true');
      p.insertBefore(dot, p.firstChild);
    }
  }

  /* ---- Part 4 ---- */

  function centrePaginationFooter() {
    var f = document.querySelector('.pagination__footer');
    if (!f) return;

    // Always measure from the untransformed position so this is idempotent.
    f.style.removeProperty('transform');

    var vw = document.documentElement.clientWidth;
    if (!vw || vw < 720) return;

    var r = f.getBoundingClientRect();
    if (!r.width) return;

    var shift = Math.round(vw / 2 - (r.left + r.width / 2));
    if (Math.abs(shift) < 1) return;

    f.style.setProperty('transform', 'translateX(' + shift + 'px)', 'important');
  }

  /* ---- scheduling ---- */

  var scheduled = null;
  function tick() {
    if (scheduled) return;
    scheduled = window.requestAnimationFrame(function () {
      scheduled = null;
      applyBottomInset();
      addStockDot();
      centrePaginationFooter();
      dedupeTypeOptions();
      applyLiveTypes(); // cached only, never refetches
    });
  }

  function init() {
    dedupeTypeOptions();
    loadLiveTypes();
    tidyHeading();
    addStockDot();
    centrePaginationFooter();
    document.addEventListener('change', onChange);

    tick();
    [400, 1200, 2500, 5000].forEach(function (ms) { window.setTimeout(tick, ms); });
    window.addEventListener('resize', tick);
    window.addEventListener('orientationchange', tick);
    document.addEventListener('cart:updated', tick);
    document.addEventListener('quick-cart:open', tick);
    if (window.MutationObserver) {
      try {
        new MutationObserver(tick).observe(document.body, { childList: true, subtree: true });
      } catch (e) { /* no-op */ }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
